export default {
    TRANS_UNION: 'tu',
};
